import cookieApi from './cookie.js';

const CONSENT_COOKIE = 'catch-consent';

const DEFAULT_CONSENT = {
  version: '',
  updatedAt: '',
  source: 'unset',
  categories: {
    necessary: true,
    functional: false,
    analytics: false,
    targeting: false,
  },
};

export function readConsentState() {
  const raw = cookieApi.read(CONSENT_COOKIE);
  if (!raw) {
    return { ...DEFAULT_CONSENT };
  }

  try {
    const parsed = JSON.parse(raw);
    return {
      version: String(parsed.version || ''),
      updatedAt: parsed.updatedAt || '',
      source: parsed.source || 'custom',
      categories: {
        ...DEFAULT_CONSENT.categories,
        ...(parsed.categories || {}),
        necessary: true,
      },
    };
  } catch {
    return { ...DEFAULT_CONSENT, source: 'invalid' };
  }
}

export default {
  readConsentState,
};
